var _rect, _rect2, _line, _line2, _ellipse, _ellipse2, _tspan, _tspan2, _rect3, _rect4, _g, _g2, _g3, _g4, _tspan3, _tspan4, _line3, _line4, _line5, _line6, _line7, _line8, _tspan5, _rect5, _rect6, _g5, _rect7, _rect8, _tspan6, _tspan7, _tspan8, _rect9, _line9, _line0, _line1, _tspan9, _tspan0, _tspan1, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2, _line10, _line11, _line12, _line13, _line14, _line15, _circle3, _circle4, _line16, _circle5, _circle6, _circle7, _circle8, _path0, _tspan10, _tspan11, _tspan12, _tspan13, _circle9, _circle0, _circle1, _circle10, _line17, _line18, _line19, _line20, _path1, _path10, _path11, _path12, _path13, _circle11, _circle12, _circle13, _circle14, _tspan14, _tspan15, _tspan16, _tspan17, _circle15, _circle16, _line21, _path14, _path15, _path16, _line22, _path17, _circle17, _circle18, _circle19, _circle20, _tspan18, _tspan19, _tspan20, _tspan21, _circle21, _circle22, _line23, _circle23, _circle24, _line24, _path18, _path19, _circle25, _circle26, _circle27, _circle28, _tspan22, _tspan23, _tspan24, _tspan25, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _path20, _tspan26, _tspan27, _tspan28, _tspan29, _line25, _path21, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _tspan30, _tspan31, _tspan32, _tspan33, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _path22, _tspan34, _tspan35, _tspan36, _tspan37, _tspan38, _tspan39, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _tspan40, _tspan41, _tspan42, _tspan43, _tspan44, _tspan45, _tspan46, _tspan47, _tspan48, _tspan49, _path23, _tspan50, _rect0, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _tspan51, _circle62, _g6, _tspan52, _g7, _tspan53, _circle63, _circle64, _g8, _tspan54, _tspan55, _tspan56, _tspan57, _tspan58, _tspan59, _tspan60, _tspan61, _tspan62, _tspan63, _tspan64, _tspan65, _tspan66, _tspan67, _tspan68, _g9, _line26, _g0, _line27, _line28, _g1, _g10, _line29, _tspan69, _tspan70, _tspan71, _tspan72, _path24, _path25, _path26, _path27, _line30, _line31, _tspan73, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _circle65, _circle66, _path35, _circle67, _path36, _line42, _line43, _line44, _line45, _tspan74, _tspan75, _rect1, _tspan76, _tspan77, _tspan78, _tspan79, _tspan80, _tspan81, _tspan82, _tspan83, _tspan84, _tspan85, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _tspan86, _tspan87, _tspan88, _tspan89, _tspan90, _tspan91, _g11, _g12, _g13, _g14, _tspan92, _tspan93, _tspan94, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPmCircuitParallel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1547,
    height: 918,
    viewBox: "0 0 1547 918",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1547,
    height: 918,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Parralel Point",
    clipPath: "url(#clip0_0_1)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1547,
    height: 918,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RELAY ROOM"
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "b24",
    x1: 51,
    y1: 168.5,
    x2: 162,
    y2: 168.5,
    stroke: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "n24",
    y1: -0.5,
    x2: 111.132,
    y2: -0.5,
    transform: "matrix(0.999838 -0.0179955 0.0170983 0.999854 50.023 287.52)",
    stroke: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 1",
    cx: 41.5,
    cy: 168.5,
    rx: 9.5,
    ry: 8.5,
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2",
    cx: 41.5,
    cy: 286,
    rx: 9.5,
    ry: 10,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "B110",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 62,
    y: 180.864
  }, "B110"))), /*#__PURE__*/React.createElement("text", {
    id: "N110",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 58,
    y: 299.864
  }, "N110"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3",
    x: 1.5,
    y: 1.5,
    width: 812,
    height: 389,
    stroke: "black",
    strokeWidth: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 8",
    x: 846.5,
    y: 1.5,
    width: 699,
    height: 915,
    stroke: "black",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-1_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164 153H199V297H164V153Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164 153H199V297H164V153Z",
    fill: "white",
    fillOpacity: 0.79,
    stroke: "black",
    strokeWidth: 4,
    mask: "url(#path-9-inside-1_0_1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-2_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301 153H341V296H301V153Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301 153H341V296H301V153Z",
    fill: "#FEFBFB",
    fillOpacity: 0.79,
    stroke: "black",
    strokeWidth: 4,
    mask: "url(#path-10-inside-2_0_1)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-3_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301 153H341V296H301V153Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301 153H341V296H301V153Z",
    fill: "white",
    fillOpacity: 0.79,
    stroke: "black",
    strokeWidth: 4,
    mask: "url(#path-11-inside-3_0_1)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-4_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446 153H487V296H446V153Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M446 153H487V296H446V153Z",
    fill: "white",
    fillOpacity: 0.79,
    stroke: "black",
    strokeWidth: 4,
    mask: "url(#path-12-inside-4_0_1)"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "WRPR/WNPR",
    transform: "matrix(0 -1 1 0 310 289)",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14.4545
  }, "WRPR/WNPR"))), /*#__PURE__*/React.createElement("text", {
    id: "NWR/RWR",
    transform: "matrix(0 -1 1 0 173 264)",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14.4545
  }, "NWR/RWR"))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line 1",
    x1: 197,
    y1: 168.5,
    x2: 301,
    y2: 168.5,
    stroke: "black"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line 2",
    x1: 197,
    y1: 284.5,
    x2: 301,
    y2: 284.5,
    stroke: "black"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Line 4",
    x1: 342,
    y1: 168.5,
    x2: 446,
    y2: 168.5,
    stroke: "black"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "Line 6",
    x1: 487,
    y1: 284.5,
    x2: 590,
    y2: 284.5,
    stroke: "black"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "Line 5",
    x1: 487,
    y1: 168.5,
    x2: 590,
    y2: 168.5,
    stroke: "black"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "Line 3",
    x1: 341,
    y1: 284.5,
    x2: 446,
    y2: 284.5,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "WCR",
    transform: "matrix(0 -1 1 0 454 251)",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14.4545
  }, "WCR"))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "RR",
    x: 914.5,
    y: 221.5,
    width: 181,
    height: 564,
    fill: "white",
    stroke: "black",
    strokeDasharray: "2 2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "RR_2",
    x: 1127.5,
    y: 223.5,
    width: 77,
    height: 564,
    fill: "white",
    stroke: "black",
    strokeDasharray: "2 2"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "LB"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-24-inside-5_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1223 223H1350V788H1223V223Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1223 223H1350V788H1223V223Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeDasharray: "2 2",
    mask: "url(#path-24-inside-5_0_1)"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "LB_2",
    x: 1373.5,
    y: 223.5,
    width: 127,
    height: 564,
    fill: "white",
    stroke: "black",
    strokeDasharray: "2 2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "PM_B",
    x: 1410,
    y: 580,
    width: 54,
    height: 206,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM_B_CW_LABEL",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 1422,
    y: 756.864
  }, "CW"))), /*#__PURE__*/React.createElement("text", {
    id: "PM_B_RW_LABEL",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 1422,
    y: 706.864
  }, "RW"))), /*#__PURE__*/React.createElement("text", {
    id: "PM_B_NW_LABEL",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 1422,
    y: 608.864
  }, "NW"))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "PM_A",
    x: 1410,
    y: 262,
    width: 54,
    height: 206,
    fill: "#D9D9D9"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    id: "WIRE_PM_B_CW_LB2PM",
    x1: 1298,
    y1: 753.5,
    x2: 1410,
    y2: 753.5,
    stroke: "black"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    id: "WIRE_PM_B_RW_LB2PM",
    x1: 1298,
    y1: 702.5,
    x2: 1410,
    y2: 702.5,
    stroke: "black"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    id: "WIRE_PM_B_NW_LB2PM",
    x1: 1298,
    y1: 604.5,
    x2: 1410,
    y2: 604.5,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM_A_NW_LABEL",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 1422,
    y: 285.864
  }, "NW"))), /*#__PURE__*/React.createElement("text", {
    id: "PM_A_RW_LABEL",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan0 || (_tspan0 = /*#__PURE__*/React.createElement("tspan", {
    x: 1422,
    y: 384.864
  }, "RW"))), /*#__PURE__*/React.createElement("text", {
    id: "PM_A_CW_LABEL",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan1 || (_tspan1 = /*#__PURE__*/React.createElement("tspan", {
    x: 1422,
    y: 440.864
  }, "CW"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "WIRE_PM_ACW_LB2PM_",
    d: "M1298 437L1410 437",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "WIRE_PM_A_RW_LB2PM",
    d: "M1298 381L1410 381",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "WIRE_PM_A_NW_LB2PM",
    d: "M1298 283L1410 283",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "WIRE_PM_A_NW_LB2PM_2",
    d: "M1171 283L1278 283",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "WIRE_PM_A_NW_LB2PM_3",
    d: "M1171 437L1278 437",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "WIRE_PM_A_NW_LB2PM_4",
    d: "M1171 604H1278",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "WIRE_PM_A_NW_LB2PM_5",
    d: "M1171 381L1278 381",
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "WIRE_PM_A_NW_LB2PM_6",
    d: "M1171 701L1280.5 702.5",
    stroke: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "WIRE_PM_A_NW_LB2PM_7",
    d: "M1171 752H1278",
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "LB_PM_A_NW_OUT",
    cx: 1299,
    cy: 283,
    r: 3,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "LB_PM_A_NW_IN",
    cx: 1281,
    cy: 283,
    r: 3,
    fill: "black"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    id: "LB_PM_A_NW_CONNECTOR",
    x1: 1282,
    y1: 283.5,
    x2: 1298,
    y2: 283.5,
    stroke: "black"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    id: "LB_PM_A_RW_CONNECTOR",
    x1: 1282,
    y1: 381.5,
    x2: 1298,
    y2: 381.5,
    stroke: "black"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    id: "LB_PM_A_CW_CONNECTOR",
    x1: 1282,
    y1: 437.5,
    x2: 1298,
    y2: 438.5,
    stroke: "black"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    id: "LB_PM_B_NW_CONNECTOR",
    x1: 1282,
    y1: 604.5,
    x2: 1298,
    y2: 607.5,
    stroke: "black"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    id: "LB_PM_B_RW_CONNECTOR",
    x1: 1282,
    y1: 702.5,
    x2: 1298,
    y2: 703.5,
    stroke: "black"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    id: "LB_PM_B_CW_CONNECTOR",
    x1: 1282,
    y1: 753.5,
    x2: 1298,
    y2: 755.5,
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "CTR_PM_A_CTR_NW_OUT",
    cx: 1173,
    cy: 283,
    r: 3,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "CTR_PM_A_CTR_NW_IN",
    cx: 1154,
    cy: 283,
    r: 3,
    fill: "black"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    id: "WIRE_PM_A_RR_IN",
    x1: 902,
    y1: 283.5,
    x2: 908,
    y2: 289.5,
    stroke: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C1",
    cx: 1034,
    cy: 283,
    r: 3,
    fill: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C2",
    cx: 1034,
    cy: 306,
    r: 3,
    fill: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C3",
    cx: 1075,
    cy: 283,
    r: 3,
    fill: "black"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C4",
    cx: 1075,
    cy: 306,
    r: 3,
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "NWR_PM_A_NW",
    d: "M1046.58 283H1033.08L1027 287.583V305H1033.08L1046.58 283ZM1046.58 283H1059.42M1059.42 283H1072.92L1079 287.583V305H1072.92L1059.42 283Z",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "C1",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 1030,
    y: 274.955
  }, "C1"))), /*#__PURE__*/React.createElement("text", {
    id: "C2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 1030,
    y: 313.955
  }, "C2"))), /*#__PURE__*/React.createElement("text", {
    id: "C3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 1071,
    y: 271.955
  }, "C3"))), /*#__PURE__*/React.createElement("text", {
    id: "C4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 1071,
    y: 313.955
  }, "C4"))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "CTR_PM_A_CTR_NW_OUT_2",
    cx: 1171,
    cy: 381,
    r: 3,
    fill: "black"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    id: "CTR_PM_A_CTR_NW_OUT_3",
    cx: 1171,
    cy: 437,
    r: 3,
    fill: "black"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    id: "CTR_PM_A_CTR_NW_OUT_4",
    cx: 1153,
    cy: 437,
    r: 3,
    fill: "black"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "CTR_PM_A_CTR_NW_IN_2",
    cx: 1153,
    cy: 381,
    r: 3,
    fill: "black"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    id: "CTR_PM_A_RW_CONNECTOR",
    x1: 1152,
    y1: 381.5,
    x2: 1169,
    y2: 381.5,
    stroke: "black"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    id: "CTR_PM_A_NW_CONNECTOR",
    x1: 1153,
    y1: 283.5,
    x2: 1170,
    y2: 283.5,
    stroke: "black"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    id: "CTR_PM_A_CW_CONNECTOR",
    x1: 1152,
    y1: 437.5,
    x2: 1169,
    y2: 437.5,
    stroke: "black"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    id: "NO ID",
    x1: 988,
    y1: 283.5,
    x2: 1033,
    y2: 283.5,
    stroke: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "WIRE_PM_A_CW_RR2CTR",
    d: "M990 437H1150",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "WIRE_PM_A_NW_RR2CTR",
    d: "M1073 283H1152",
    stroke: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "WIRE_PM_A_RW_RR2CTR",
    d: "M1073 381H1151",
    stroke: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "NO ID_2",
    d: "M1033.16 305.481L1017.33 314.998L1017.33 382.332L1033.16 382.332",
    stroke: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "RWR_PM_A_RW",
    d: "M1046.58 381H1033.08L1027 386V405H1033.08L1046.58 381ZM1046.58 381H1059.42M1059.42 381H1072.92L1079 386V405H1072.92L1059.42 381Z",
    stroke: "black"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C1_2",
    cx: 1034,
    cy: 382,
    r: 3,
    fill: "black"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C2_2",
    cx: 1034,
    cy: 404,
    r: 3,
    fill: "black"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C3_2",
    cx: 1075,
    cy: 382,
    r: 3,
    fill: "black"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C4_2",
    cx: 1075,
    cy: 404,
    r: 3,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "C1_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 1030,
    y: 372.955
  }, "C1"))), /*#__PURE__*/React.createElement("text", {
    id: "C2_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 1030,
    y: 413.955
  }, "C2"))), /*#__PURE__*/React.createElement("text", {
    id: "C3_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 1071,
    y: 370.955
  }, "C3"))), /*#__PURE__*/React.createElement("text", {
    id: "C4_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 1071,
    y: 413.955
  }, "C4"))), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    id: "CTR_PM_A_CTR_NW_OUT_5",
    cx: 1171,
    cy: 604,
    r: 3,
    fill: "black"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    id: "CTR_PM_A_CTR_NW_OUT_6",
    cx: 1153,
    cy: 604,
    r: 3,
    fill: "black"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    id: "CTR_PM_B_NW_CONNECTOR",
    x1: 1154,
    y1: 604,
    x2: 1171,
    y2: 604,
    stroke: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "NO ID_3",
    d: "M990 458V752H1153",
    stroke: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "WIRE_PM_B_RW_RR2CTR",
    d: "M1073 701H1153",
    stroke: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "WIRE_PM_B_NW_RR2CTR",
    d: "M1073 604H1156",
    stroke: "black"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    id: "WIRE_PM_A_RR2CTR_NW",
    x1: 1004,
    y1: 604.5,
    x2: 1033,
    y2: 604.5,
    stroke: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "NWR_PM_B_NW",
    d: "M1046.58 604H1033.08L1027 608.792V627H1033.08L1046.58 604ZM1046.58 604H1059.42M1059.42 604H1072.92L1079 608.792V627H1072.92L1059.42 604Z",
    stroke: "black"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C1_3",
    cx: 1034,
    cy: 605,
    r: 3,
    fill: "black"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C2_3",
    cx: 1034,
    cy: 627,
    r: 3,
    fill: "black"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C3_3",
    cx: 1075,
    cy: 605,
    r: 3,
    fill: "black"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C4_3",
    cx: 1075,
    cy: 627,
    r: 3,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "NO_ID_C1_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 1030,
    y: 595.955
  }, "C1"))), /*#__PURE__*/React.createElement("text", {
    id: "C2_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 1030,
    y: 634.955
  }, "C2"))), /*#__PURE__*/React.createElement("text", {
    id: "C3_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 1071,
    y: 593.955
  }, "C3"))), /*#__PURE__*/React.createElement("text", {
    id: "C4_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 1071,
    y: 634.955
  }, "C4"))), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    id: "CTR_PM_A_NW_OUT",
    cx: 1171,
    cy: 701,
    r: 3,
    fill: "black"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    id: "CTR_PM_A_NW_IN",
    cx: 1153,
    cy: 701,
    r: 3,
    fill: "black"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    id: "CTR_PM_B_RW_CONNECTOR",
    x1: 1152,
    y1: 700.5,
    x2: 1170,
    y2: 706.5,
    stroke: "black"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    id: "CTR_PM_A_NW_OUT_2",
    cx: 1171,
    cy: 753,
    r: 3,
    fill: "black"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    id: "CTR_PM_A_NW_IN_2",
    cx: 1153,
    cy: 753,
    r: 3,
    fill: "black"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    id: "CTR_PM_B_CW_CONNECTOR",
    x1: 1152,
    y1: 753.5,
    x2: 1169,
    y2: 753.5,
    stroke: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "WIRE_PM_A_RR2CTR_NW_2",
    d: "M1033.16 628.112L1017.33 636.677L1017.33 702.095L1033.16 702.095",
    stroke: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "RWR_PM_B_RW",
    d: "M1046.58 701H1033.08L1027 705.792V724H1033.08L1046.58 701ZM1046.58 701H1059.42M1059.42 701H1072.92L1079 705.792V724H1072.92L1059.42 701Z",
    stroke: "black"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C1_5",
    cx: 1034,
    cy: 702,
    r: 3,
    fill: "black"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C2_4",
    cx: 1034,
    cy: 726,
    r: 3,
    fill: "black"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C3_4",
    cx: 1075,
    cy: 702,
    r: 3,
    fill: "black"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C4_4",
    cx: 1075,
    cy: 726,
    r: 3,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "NO_ID_C1_6",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 1030,
    y: 694.955
  }, "C1"))), /*#__PURE__*/React.createElement("text", {
    id: "NO_ID_C2_5",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 1030,
    y: 734.955
  }, "C2"))), /*#__PURE__*/React.createElement("text", {
    id: "NO_ID_C3_5",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 1071,
    y: 693.955
  }, "C3"))), /*#__PURE__*/React.createElement("text", {
    id: "NO_ID_C4_5",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 1071,
    y: 734.955
  }, "C4"))), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C1_7",
    cx: 948,
    cy: 283,
    r: 3,
    fill: "black"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    id: "B110V_BB_PM",
    cx: 902,
    cy: 283,
    r: 3,
    fill: "black"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    id: "N110V_BB_PM",
    cx: 902,
    cy: 437,
    r: 3,
    fill: "black"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C2_6",
    cx: 948,
    cy: 306,
    r: 3,
    fill: "black"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C3_6",
    cx: 990,
    cy: 283,
    r: 3,
    fill: "black"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    id: "NO_ID_C4_6",
    cx: 990,
    cy: 306,
    r: 3,
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "WCR_PM_A",
    d: "M961.584 283H948.078L942 287.583V305H948.078L961.584 283ZM961.584 283H974.416M974.416 283H987.922L994 287.583V305H987.922L974.416 283Z",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "C1_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 944,
    y: 274.955
  }, "C1"))), /*#__PURE__*/React.createElement("text", {
    id: "C2_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 944,
    y: 313.955
  }, "C2"))), /*#__PURE__*/React.createElement("text", {
    id: "C3_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    x: 986,
    y: 271.955
  }, "C3"))), /*#__PURE__*/React.createElement("text", {
    id: "C4_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    x: 986,
    y: 313.955
  }, "C4"))), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    id: "WIRE_PM_A_RR_IN_2",
    x1: 902,
    y1: 437.5,
    x2: 949,
    y2: 437.5,
    stroke: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "WCR_PM_B",
    d: "M962.961 437H949.195L943 441.583V459H949.195L962.961 437ZM962.961 437H976.039M976.039 437H989.805L996 441.583V459H989.805L976.039 437Z",
    stroke: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "NO_ID_C1_8",
    cx: 949,
    cy: 436.5,
    rx: 2,
    ry: 2.5,
    fill: "black"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "NO_ID_C2_7",
    cx: 949,
    cy: 460,
    rx: 2,
    ry: 3,
    fill: "black"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    id: "NO_ID_C3_7",
    cx: 990,
    cy: 436.5,
    rx: 2,
    ry: 2.5,
    fill: "black"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    id: "NO_ID_C4_7",
    cx: 990,
    cy: 460,
    rx: 2,
    ry: 3,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "C1_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    x: 945,
    y: 428.955
  }, "C1"))), /*#__PURE__*/React.createElement("text", {
    id: "C2_5",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan31 || (_tspan31 = /*#__PURE__*/React.createElement("tspan", {
    x: 945,
    y: 467.955
  }, "C2"))), /*#__PURE__*/React.createElement("text", {
    id: "C3_5",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan32 || (_tspan32 = /*#__PURE__*/React.createElement("tspan", {
    x: 987,
    y: 426.955
  }, "C3"))), /*#__PURE__*/React.createElement("text", {
    id: "C4_5",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 4,
    letterSpacing: "0em"
  }, _tspan33 || (_tspan33 = /*#__PURE__*/React.createElement("tspan", {
    x: 980,
    y: 466.955
  }, "C4"))), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    id: "LB_PM_A_RW_OUT",
    cx: 1299,
    cy: 381,
    r: 3,
    fill: "black"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    id: "LB_PM_A_RW_IN",
    cx: 1281,
    cy: 381,
    r: 3,
    fill: "black"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    id: "LB_PM_A_CW_OUT",
    cx: 1299,
    cy: 437,
    r: 3,
    fill: "black"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    id: "LB_PM_A_CW_IN",
    cx: 1281,
    cy: 437,
    r: 3,
    fill: "black"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    id: "LB_PM_B_NW_OUT",
    cx: 1299,
    cy: 604,
    r: 3,
    fill: "black"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    id: "LB_PM_B_NW_IN",
    cx: 1281,
    cy: 604,
    r: 3,
    fill: "black"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    id: "LB_PM_B_RW_OUT",
    cx: 1299,
    cy: 702,
    r: 3,
    fill: "black"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    id: "LB_PM_B_RW_IN",
    cx: 1281,
    cy: 702,
    r: 3,
    fill: "black"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    id: "LB_PM_B_CW_OUT",
    cx: 1299,
    cy: 753,
    r: 3,
    fill: "black"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    id: "LB_PM_B_CW_IN",
    cx: 1281,
    cy: 753,
    r: 3,
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "NP ID",
    d: "M988 306L1004 321.233V604",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "B110_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan34 || (_tspan34 = /*#__PURE__*/React.createElement("tspan", {
    x: 863,
    y: 295.864
  }, "B110"))), /*#__PURE__*/React.createElement("text", {
    id: "N110_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan35 || (_tspan35 = /*#__PURE__*/React.createElement("tspan", {
    x: 863,
    y: 449.864
  }, "N110"))), /*#__PURE__*/React.createElement("text", {
    id: "LOCATION BOX",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10,
    letterSpacing: "0em"
  }, _tspan36 || (_tspan36 = /*#__PURE__*/React.createElement("tspan", {
    x: 1231,
    y: 208.636
  }, "LOCATION BOX"))), /*#__PURE__*/React.createElement("text", {
    id: "Machine Location",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10,
    letterSpacing: "0em"
  }, _tspan37 || (_tspan37 = /*#__PURE__*/React.createElement("tspan", {
    x: 1390,
    y: 208.636
  }, "Machine Location"))), /*#__PURE__*/React.createElement("text", {
    id: "CT RACK",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10,
    letterSpacing: "0em"
  }, _tspan38 || (_tspan38 = /*#__PURE__*/React.createElement("tspan", {
    x: 1135,
    y: 208.636
  }, "CT RACK"))), /*#__PURE__*/React.createElement("text", {
    id: "RELAY ROOM_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10,
    letterSpacing: "0em"
  }, _tspan39 || (_tspan39 = /*#__PURE__*/React.createElement("tspan", {
    x: 963,
    y: 208.636
  }, "RELAY ROOM"))), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 100",
    cx: 1416,
    cy: 281,
    r: 6,
    fill: "black"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 101",
    cx: 1416,
    cy: 381,
    r: 6,
    fill: "black"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 102",
    cx: 1416,
    cy: 436,
    r: 6,
    fill: "black"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 103",
    cx: 1416,
    cy: 604,
    r: 6,
    fill: "black"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 104",
    cx: 1416,
    cy: 703,
    r: 6,
    fill: "black"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 105",
    cx: 1416,
    cy: 753,
    r: 6,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Point Machine A end motor",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan40 || (_tspan40 = /*#__PURE__*/React.createElement("tspan", {
    x: 1403,
    y: 231.909
  }, "Point Machine")), _tspan41 || (_tspan41 = /*#__PURE__*/React.createElement("tspan", {
    x: 1403,
    y: 241.909
  }, "'A' end motor"))), /*#__PURE__*/React.createElement("text", {
    id: "Point Machine B end motor",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan42 || (_tspan42 = /*#__PURE__*/React.createElement("tspan", {
    x: 1403,
    y: 547.909
  }, "Point Machine")), _tspan43 || (_tspan43 = /*#__PURE__*/React.createElement("tspan", {
    x: 1403,
    y: 557.909
  }, "'B' end motor"))), /*#__PURE__*/React.createElement("text", {
    id: "NW_PointA",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan44 || (_tspan44 = /*#__PURE__*/React.createElement("tspan", {
    x: 1233,
    y: 374.5
  }, ".........."))), /*#__PURE__*/React.createElement("text", {
    id: "RW_PointA",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan45 || (_tspan45 = /*#__PURE__*/React.createElement("tspan", {
    x: 1233,
    y: 273.5
  }, ".........."))), /*#__PURE__*/React.createElement("text", {
    id: "CW_PointA",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan46 || (_tspan46 = /*#__PURE__*/React.createElement("tspan", {
    x: 1233,
    y: 429.5
  }, ".........."))), /*#__PURE__*/React.createElement("text", {
    id: "NW_PointB",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan47 || (_tspan47 = /*#__PURE__*/React.createElement("tspan", {
    x: 1233,
    y: 597.5
  }, ".........."))), /*#__PURE__*/React.createElement("text", {
    id: "RW_PointB",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan48 || (_tspan48 = /*#__PURE__*/React.createElement("tspan", {
    x: 1233,
    y: 696.5
  }, ".........."))), /*#__PURE__*/React.createElement("text", {
    id: "CW_PointB",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan49 || (_tspan49 = /*#__PURE__*/React.createElement("tspan", {
    x: 1233,
    y: 747.5
  }, "..........")))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3",
    d: "M633.5 233C633.5 255.049 630.259 274.989 625.036 289.398C622.424 296.605 619.325 302.402 615.908 306.388C612.491 310.375 608.803 312.5 605 312.5C601.197 312.5 597.509 310.375 594.092 306.388C590.675 302.402 587.576 296.605 584.964 289.398C579.741 274.989 576.5 255.049 576.5 233C576.5 210.951 579.741 191.011 584.964 176.602C587.576 169.395 590.675 163.598 594.092 159.612C597.509 155.625 601.197 153.5 605 153.5C608.803 153.5 612.491 155.625 615.908 159.612C619.325 163.598 622.424 169.395 625.036 176.602C630.259 191.011 633.5 210.951 633.5 233Z",
    fill: "white",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "110V DC",
    transform: "matrix(0 -1 1 0 596 258)",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan50 || (_tspan50 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14.4545
  }, "110V DC"))), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11",
    x: 1.5,
    y: 422.5,
    width: 812,
    height: 492,
    stroke: "black",
    strokeWidth: 3
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 30",
    cx: 62.5,
    cy: 518.5,
    r: 7,
    fill: "#D9D9D9",
    stroke: "black"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 31",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 134 511)",
    fill: "#D9D9D9",
    stroke: "black"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 32",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 164 510)",
    stroke: "black"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 47",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 166 719)",
    stroke: "black"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 166 827)",
    stroke: "black"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 226 828)",
    stroke: "black"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 164 629)",
    stroke: "black"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 223 510)",
    stroke: "black"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 59",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 453 510)",
    stroke: "black"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 60",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 512 510)",
    stroke: "black"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 225 719)",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "LOCATION BOX_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan51 || (_tspan51 = /*#__PURE__*/React.createElement("tspan", {
    x: 430,
    y: 474.864
  }, "LOCATION  BOX"))), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 35",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 223 629)",
    stroke: "black"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "RWKR_INDOOR"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-187-inside-6_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74 517H115V534H74V517Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74 517H115V534H74V517Z",
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-187-inside-6_0_1)"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "RWKR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan52 || (_tspan52 = /*#__PURE__*/React.createElement("tspan", {
    x: 75,
    y: 528.864
  }, "RWKR"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "RWKR_OUTDOOR"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-189-inside-7_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455 518H496V535H455V518Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M455 518H496V535H455V518Z",
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-189-inside-7_0_1)"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "RWKR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan53 || (_tspan53 = /*#__PURE__*/React.createElement("tspan", {
    x: 456,
    y: 528.864
  }, "RWKR"))), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 61",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 453 720)",
    stroke: "black"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 62",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 512 720)",
    stroke: "black"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "NWKR_OUTDOOR"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-193-inside-8_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455 727H496V744H455V727Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M455 727H496V744H455V727Z",
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-193-inside-8_0_1)"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "NWKR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan54 || (_tspan54 = /*#__PURE__*/React.createElement("tspan", {
    x: 456,
    y: 738.864
  }, "NWKR"))), /*#__PURE__*/React.createElement("text", {
    id: "NWKR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan55 || (_tspan55 = /*#__PURE__*/React.createElement("tspan", {
    x: 79,
    y: 738.864
  }, "NWKR"))), /*#__PURE__*/React.createElement("text", {
    id: "R1",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan56 || (_tspan56 = /*#__PURE__*/React.createElement("tspan", {
    x: 111,
    y: 545.864
  }, "R1"))), /*#__PURE__*/React.createElement("text", {
    id: "R1_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan57 || (_tspan57 = /*#__PURE__*/React.createElement("tspan", {
    x: 121,
    y: 760.864
  }, "R1"))), /*#__PURE__*/React.createElement("text", {
    id: "R2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan58 || (_tspan58 = /*#__PURE__*/React.createElement("tspan", {
    x: 65,
    y: 545.864
  }, "R2"))), /*#__PURE__*/React.createElement("text", {
    id: "R2_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan59 || (_tspan59 = /*#__PURE__*/React.createElement("tspan", {
    x: 66,
    y: 760.864
  }, "R2"))), /*#__PURE__*/React.createElement("text", {
    id: "RWR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan60 || (_tspan60 = /*#__PURE__*/React.createElement("tspan", {
    x: 172,
    y: 513.864
  }, "RWR"))), /*#__PURE__*/React.createElement("text", {
    id: "A7",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan61 || (_tspan61 = /*#__PURE__*/React.createElement("tspan", {
    x: 208,
    y: 505.864
  }, "A7"))), /*#__PURE__*/React.createElement("text", {
    id: "A7_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan62 || (_tspan62 = /*#__PURE__*/React.createElement("tspan", {
    x: 210,
    y: 709.864
  }, "A7"))), /*#__PURE__*/React.createElement("text", {
    id: "A7_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan63 || (_tspan63 = /*#__PURE__*/React.createElement("tspan", {
    x: 145,
    y: 819.864
  }, "A7"))), /*#__PURE__*/React.createElement("text", {
    id: "A7_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan64 || (_tspan64 = /*#__PURE__*/React.createElement("tspan", {
    x: 145,
    y: 625.864
  }, "A7"))), /*#__PURE__*/React.createElement("text", {
    id: "A8",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan65 || (_tspan65 = /*#__PURE__*/React.createElement("tspan", {
    x: 148,
    y: 505.864
  }, "A8"))), /*#__PURE__*/React.createElement("text", {
    id: "A8_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan66 || (_tspan66 = /*#__PURE__*/React.createElement("tspan", {
    x: 209,
    y: 625.864
  }, "A8"))), /*#__PURE__*/React.createElement("text", {
    id: "A8_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan67 || (_tspan67 = /*#__PURE__*/React.createElement("tspan", {
    x: 151,
    y: 709.864
  }, "A8"))), /*#__PURE__*/React.createElement("text", {
    id: "A8_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan68 || (_tspan68 = /*#__PURE__*/React.createElement("tspan", {
    x: 207,
    y: 819.864
  }, "A8"))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 34_2",
    d: "M296.134 516.89C296.134 523.037 300.946 527.991 306.846 527.991C312.746 527.991 317.558 523.037 317.558 516.89C317.558 510.742 312.746 505.788 306.846 505.788C300.946 505.788 296.134 510.742 296.134 516.89Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 35_2",
    d: "M389.035 516.89C389.035 523.037 393.847 527.991 399.747 527.991C405.647 527.991 410.459 523.037 410.459 516.89C410.459 510.742 405.647 505.788 399.747 505.788C393.847 505.788 389.035 510.742 389.035 516.89Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 59",
    x1: 307.38,
    y1: 505.893,
    x2: 400.281,
    y2: 505.893,
    stroke: "black"
  }))), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    id: "Line 60",
    x1: 306,
    y1: 527.5,
    x2: 399,
    y2: 527.5,
    stroke: "black"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 34_3",
    d: "M290.795 636.22C290.795 642.367 295.607 647.321 301.507 647.321C307.407 647.321 312.219 642.367 312.219 636.22C312.219 630.072 307.407 625.118 301.507 625.118C295.607 625.118 290.795 630.072 290.795 636.22Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 35_3",
    d: "M383.696 636.22C383.696 642.367 388.508 647.321 394.408 647.321C400.308 647.321 405.12 642.367 405.12 636.22C405.12 630.072 400.308 625.118 394.408 625.118C388.508 625.118 383.696 630.072 383.696 636.22Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 59_2",
    x1: 302.041,
    y1: 625.223,
    x2: 394.942,
    y2: 625.223,
    stroke: "black"
  })))), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    id: "Line 63",
    x1: 302,
    y1: 647.5,
    x2: 395,
    y2: 647.5,
    stroke: "black"
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    id: "Line 61",
    x1: 556,
    y1: 529.5,
    x2: 649,
    y2: 529.5,
    stroke: "black"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 34_4",
    d: "M544.833 517.994C544.833 524.142 549.645 529.096 555.545 529.096C561.445 529.096 566.257 524.142 566.257 517.994C566.257 511.847 561.445 506.893 555.545 506.893C549.645 506.893 544.833 511.847 544.833 517.994Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 35_4",
    d: "M637.733 517.994C637.733 524.142 642.545 529.096 648.446 529.096C654.346 529.096 659.158 524.142 659.158 517.994C659.158 511.847 654.346 506.893 648.446 506.893C642.545 506.893 637.733 511.847 637.733 517.994Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 59_3",
    x1: 556.079,
    y1: 506.998,
    x2: 648.98,
    y2: 506.998,
    stroke: "black"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 34_5",
    d: "M544.833 636.22C544.833 642.367 549.645 647.321 555.545 647.321C561.445 647.321 566.257 642.367 566.257 636.22C566.257 630.072 561.445 625.118 555.545 625.118C549.645 625.118 544.833 630.072 544.833 636.22Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 35_5",
    d: "M637.733 636.22C637.733 642.367 642.545 647.321 648.446 647.321C654.346 647.321 659.158 642.367 659.158 636.22C659.158 630.072 654.346 625.118 648.446 625.118C642.545 625.118 637.733 630.072 637.733 636.22Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 59_4",
    x1: 556.079,
    y1: 625.223,
    x2: 648.979,
    y2: 625.223,
    stroke: "black"
  }))), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    id: "Line 65",
    x1: 556,
    y1: 647.5,
    x2: 649,
    y2: 647.5,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "B24",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan69 || (_tspan69 = /*#__PURE__*/React.createElement("tspan", {
    x: 715,
    y: 501.864
  }, "B24"))), /*#__PURE__*/React.createElement("text", {
    id: "B24_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan70 || (_tspan70 = /*#__PURE__*/React.createElement("tspan", {
    x: 715,
    y: 711.864
  }, "B24"))), /*#__PURE__*/React.createElement("text", {
    id: "N24",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan71 || (_tspan71 = /*#__PURE__*/React.createElement("tspan", {
    x: 715,
    y: 619.864
  }, "N24"))), /*#__PURE__*/React.createElement("text", {
    id: "N24_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan72 || (_tspan72 = /*#__PURE__*/React.createElement("tspan", {
    x: 715,
    y: 818.864
  }, "N24"))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "B24_PointB_RWKR_WIRE_STATUS",
    d: "M50.0408 516.942L422 518.047",
    stroke: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "B24_PointA_RWKR_WIRE_STATUS",
    d: "M422.041 517.942L741 519.047",
    stroke: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "B24_PointB_RWKR_WIRE_STATUS_2",
    d: "M50.0408 726.942L422 728.047",
    stroke: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "B24_PointA_RWKR_WIRE_STATUS_2",
    d: "M422.041 727.942L741 729.047",
    stroke: "black"
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    id: "N24_RWKR_WIRE_STATUS",
    x1: 50,
    y1: 636.5,
    x2: 741,
    y2: 636.5,
    stroke: "black"
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    id: "B24N24_RWKR_LINE",
    x1: 49.5,
    y1: 637,
    x2: 49.5,
    y2: 516,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "WRKR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan73 || (_tspan73 = /*#__PURE__*/React.createElement("tspan", {
    x: 167,
    y: 631.864
  }, "WRKR"))), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    id: "Line 69",
    y1: -0.5,
    x2: 48.6269,
    y2: -0.5,
    transform: "matrix(0.0219591 0.999759 -0.999724 0.0235101 352.229 494.239)",
    stroke: "black"
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    id: "Line 70",
    y1: -0.5,
    x2: 48.6269,
    y2: -0.5,
    transform: "matrix(0.0219591 0.999759 -0.999724 0.0235101 603.063 493.134)",
    stroke: "black"
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    id: "Line 71",
    opacity: 0.9,
    x1: 351.5,
    y1: 666,
    x2: 351.5,
    y2: 617,
    stroke: "black"
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    id: "Line 72",
    y1: -0.5,
    x2: 48.6269,
    y2: -0.5,
    transform: "matrix(0.0219591 0.999759 -0.999724 0.0235101 604.131 613.569)",
    stroke: "black"
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    id: "B24N24_NWKR_LINE",
    x1: 50.5,
    y1: 727,
    x2: 50.5,
    y2: 836,
    stroke: "black"
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    id: "N24_RWKR_WIRE_STATUS_2",
    x1: 50,
    y1: 835.5,
    x2: 741,
    y2: 835.5,
    stroke: "black"
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    id: "Line 76",
    x1: 322.5,
    y1: 556,
    x2: 322.5,
    y2: 604,
    stroke: "black"
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    id: "Line 77",
    x1: 579.5,
    y1: 554,
    x2: 579.5,
    y2: 601,
    stroke: "black"
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    id: "Line 78",
    x1: 318.5,
    y1: 762,
    x2: 318.5,
    y2: 809,
    stroke: "black"
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    id: "Line 79",
    x1: 580.5,
    y1: 761,
    x2: 580.5,
    y2: 808,
    stroke: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 36",
    d: "M315.5 835C315.5 841.922 310.109 847.5 303.5 847.5C296.891 847.5 291.5 841.922 291.5 835C291.5 828.078 296.891 822.5 303.5 822.5C310.109 822.5 315.5 828.078 315.5 835Z",
    stroke: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 45",
    d: "M350.5 785.5C350.5 792.189 345.741 797.5 340 797.5C334.259 797.5 329.5 792.189 329.5 785.5C329.5 778.811 334.259 773.5 340 773.5C345.741 773.5 350.5 778.811 350.5 785.5Z",
    stroke: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 53",
    d: "M350.5 578.5C350.5 585.189 345.741 590.5 340 590.5C334.259 590.5 329.5 585.189 329.5 578.5C329.5 571.811 334.259 566.5 340 566.5C345.741 566.5 350.5 571.811 350.5 578.5Z",
    stroke: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 54",
    d: "M612.5 576.5C612.5 583.167 607.537 588.5 601.5 588.5C595.463 588.5 590.5 583.167 590.5 576.5C590.5 569.833 595.463 564.5 601.5 564.5C607.537 564.5 612.5 569.833 612.5 576.5Z",
    stroke: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 46",
    d: "M612.5 782C612.5 788.963 607.519 794.5 601.5 794.5C595.481 794.5 590.5 788.963 590.5 782C590.5 775.037 595.481 769.5 601.5 769.5C607.519 769.5 612.5 775.037 612.5 782Z",
    stroke: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 37",
    d: "M314.5 728C314.5 734.922 309.109 740.5 302.5 740.5C295.891 740.5 290.5 734.922 290.5 728C290.5 721.078 295.891 715.5 302.5 715.5C309.109 715.5 314.5 721.078 314.5 728Z",
    stroke: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 38",
    d: "M405.5 727C405.5 733.963 400.519 739.5 394.5 739.5C388.481 739.5 383.5 733.963 383.5 727C383.5 720.037 388.481 714.5 394.5 714.5C400.519 714.5 405.5 720.037 405.5 727Z",
    stroke: "black"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 41",
    cx: 560.5,
    cy: 727.5,
    r: 12,
    stroke: "black"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 42",
    cx: 649.5,
    cy: 727.5,
    r: 12,
    stroke: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 43",
    d: "M659.5 834.5C659.5 841.167 654.537 846.5 648.5 846.5C642.463 846.5 637.5 841.167 637.5 834.5C637.5 827.833 642.463 822.5 648.5 822.5C654.537 822.5 659.5 827.833 659.5 834.5Z",
    stroke: "black"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 44",
    cx: 560.5,
    cy: 834.5,
    r: 12,
    stroke: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 39",
    d: "M407.5 835C407.5 841.922 402.109 847.5 395.5 847.5C388.891 847.5 383.5 841.922 383.5 835C383.5 828.078 388.891 822.5 395.5 822.5C402.109 822.5 407.5 828.078 407.5 835Z",
    stroke: "black"
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    id: "Line 80",
    x1: 348.5,
    y1: 709,
    x2: 348.5,
    y2: 745,
    stroke: "black"
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    id: "Line 81",
    x1: 605.5,
    y1: 710,
    x2: 605.5,
    y2: 746,
    stroke: "black"
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    id: "Line 82",
    x1: 604.5,
    y1: 816,
    x2: 604.5,
    y2: 852,
    stroke: "black"
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    id: "Line 83",
    x1: 351.5,
    y1: 817,
    x2: 351.5,
    y2: 853,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "NWR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan74 || (_tspan74 = /*#__PURE__*/React.createElement("tspan", {
    x: 175,
    y: 723.864
  }, "NWR"))), /*#__PURE__*/React.createElement("text", {
    id: "WNKR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan75 || (_tspan75 = /*#__PURE__*/React.createElement("tspan", {
    x: 167,
    y: 829.864
  }, "WNKR"))), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    id: "NWKR_INDOOR",
    x: 72.5,
    y: 727.5,
    width: 49,
    height: 20,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "C1_5",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan76 || (_tspan76 = /*#__PURE__*/React.createElement("tspan", {
    x: 642,
    y: 501.864
  }, "C1"))), /*#__PURE__*/React.createElement("text", {
    id: "C2_6",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan77 || (_tspan77 = /*#__PURE__*/React.createElement("tspan", {
    x: 643,
    y: 660.864
  }, "C2"))), /*#__PURE__*/React.createElement("text", {
    id: "C3_6",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan78 || (_tspan78 = /*#__PURE__*/React.createElement("tspan", {
    x: 639,
    y: 710.864
  }, "C3"))), /*#__PURE__*/React.createElement("text", {
    id: "C4_6",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan79 || (_tspan79 = /*#__PURE__*/React.createElement("tspan", {
    x: 639,
    y: 855.864
  }, "C4"))), /*#__PURE__*/React.createElement("text", {
    id: "C5",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan80 || (_tspan80 = /*#__PURE__*/React.createElement("tspan", {
    x: 544,
    y: 501.864
  }, "C5"))), /*#__PURE__*/React.createElement("text", {
    id: "C6",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan81 || (_tspan81 = /*#__PURE__*/React.createElement("tspan", {
    x: 549,
    y: 660.864
  }, "C6"))), /*#__PURE__*/React.createElement("text", {
    id: "C7",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan82 || (_tspan82 = /*#__PURE__*/React.createElement("tspan", {
    x: 549,
    y: 711.864
  }, "C7"))), /*#__PURE__*/React.createElement("text", {
    id: "C8",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan83 || (_tspan83 = /*#__PURE__*/React.createElement("tspan", {
    x: 543,
    y: 858.864
  }, "C8"))), /*#__PURE__*/React.createElement("text", {
    id: "B1",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan84 || (_tspan84 = /*#__PURE__*/React.createElement("tspan", {
    x: 395,
    y: 501.864
  }, "B1"))), /*#__PURE__*/React.createElement("text", {
    id: "B2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan85 || (_tspan85 = /*#__PURE__*/React.createElement("tspan", {
    x: 387,
    y: 663.864
  }, "B2"))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 16",
    d: "M293 823C293 815.842 295.378 810.113 300.003 804.653C303.461 800.571 309.729 795.312 315 794",
    stroke: "black",
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 20",
    d: "M549.226 530C549.226 534.054 548.805 538.248 549.226 542.278C549.877 548.497 552.142 553.972 556.5 559C560.5 564.5 569 571 575 570.5",
    stroke: "black",
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 25",
    d: "M548.62 624C548.273 619.961 548.495 617.681 548.62 613.625C548.814 607.366 550.876 601.693 555.315 596.264C559.314 590.4 568.256 583.106 575.004 583.027",
    stroke: "black",
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 22",
    d: "M291 743C291 759.182 298.333 776.524 314 780",
    stroke: "black",
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 28",
    d: "M554 821C554 813.842 556.378 808.113 561.003 802.653C564.461 798.571 570.729 793.312 576 792",
    stroke: "black",
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 29",
    d: "M552 741C552 757.182 559.333 774.524 575 778",
    stroke: "black",
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 26",
    d: "M299 532C299 548.182 306.333 565.524 322 569",
    stroke: "black",
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 27",
    d: "M294.037 626.026C294.021 609.844 302.175 592.494 319.63 589",
    stroke: "black",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("text", {
    id: "B3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan86 || (_tspan86 = /*#__PURE__*/React.createElement("tspan", {
    x: 386,
    y: 706.864
  }, "B3"))), /*#__PURE__*/React.createElement("text", {
    id: "B4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan87 || (_tspan87 = /*#__PURE__*/React.createElement("tspan", {
    x: 386,
    y: 858.864
  }, "B4"))), /*#__PURE__*/React.createElement("text", {
    id: "B5",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan88 || (_tspan88 = /*#__PURE__*/React.createElement("tspan", {
    x: 299,
    y: 502.864
  }, "B5"))), /*#__PURE__*/React.createElement("text", {
    id: "B6",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan89 || (_tspan89 = /*#__PURE__*/React.createElement("tspan", {
    x: 293,
    y: 663.864
  }, "B6"))), /*#__PURE__*/React.createElement("text", {
    id: "B7",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan90 || (_tspan90 = /*#__PURE__*/React.createElement("tspan", {
    x: 292,
    y: 707.864
  }, "B7"))), /*#__PURE__*/React.createElement("text", {
    id: "B8",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan91 || (_tspan91 = /*#__PURE__*/React.createElement("tspan", {
    x: 289,
    y: 859.864
  }, "B8"))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group 15"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_2",
    cx: 320.219,
    cy: 568.292,
    r: 2.5,
    fill: "#141313"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_2",
    cx: 320.219,
    cy: 589.551,
    r: 2.5,
    fill: "#141313"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group 17"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_3",
    cx: 577.8,
    cy: 778.967,
    r: 2.5,
    fill: "#141313"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_3",
    cx: 577.8,
    cy: 791.225,
    r: 2.5,
    fill: "#141313"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group 18"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_4",
    cx: 577.8,
    cy: 569.663,
    r: 2.5,
    fill: "#141313"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_4",
    cx: 577.8,
    cy: 582.922,
    r: 2.5,
    fill: "#141313"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group 16"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53_5",
    cx: 316.287,
    cy: 779.596,
    r: 2.5,
    fill: "#141313"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54_5",
    cx: 316.5,
    cy: 793.5,
    r: 2.5,
    fill: "#141313"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "\xE2\x80\x98A\xE2\x80\x99 END POINT MACHINE",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan92 || (_tspan92 = /*#__PURE__*/React.createElement("tspan", {
    x: 274,
    y: 475.864
  }, "'A' END POINT MACHINE"))), /*#__PURE__*/React.createElement("text", {
    id: "RELAY ROOM AT STATION",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan93 || (_tspan93 = /*#__PURE__*/React.createElement("tspan", {
    x: 50,
    y: 474.864
  }, "RELAY ROOM AT STATION"))), /*#__PURE__*/React.createElement("text", {
    id: "\xE2\x80\x98B\xE2\x80\x99 END POINT MACHINE",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan94 || (_tspan94 = /*#__PURE__*/React.createElement("tspan", {
    x: 539,
    y: 475.864
  }, "'B' END POINT MACHINE"))), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55",
    cx: 339,
    cy: 579,
    r: 3,
    fill: "#111010"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58",
    cx: 339,
    cy: 786,
    r: 3,
    fill: "#111010"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56",
    cx: 601,
    cy: 577,
    r: 3,
    fill: "#111010"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 63",
    cx: 743,
    cy: 519,
    r: 3,
    fill: "#111010"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 64",
    cx: 743,
    cy: 637,
    r: 3,
    fill: "#111010"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 65",
    cx: 743,
    cy: 727,
    r: 3,
    fill: "#111010"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 66",
    cx: 743,
    cy: 835,
    r: 3,
    fill: "#111010"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57",
    cx: 601,
    cy: 782,
    r: 3,
    fill: "#111010"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52",
    cx: 62.5,
    cy: 728.5,
    r: 7,
    fill: "#D9D9D9",
    stroke: "black"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    transform: "matrix(-1 0 0 1 141 720)",
    fill: "#D9D9D9",
    fillOpacity: 0.99,
    stroke: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1547,
    height: 918,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmCircuitParallel);
export default __webpack_public_path__ + "static/media/pm_circuit_parallel.e04a43d47fd4b104f7b24a2e56ec2fee.svg";
export { ForwardRef as ReactComponent };